<template>
  <div class="c-crud">
    <div class="c-crud-header" v-if="title || $slots.title || $slots.right || $slots.right || onRefresh">
      <div class="c-crud-title">
        <slot name="title">{{ title }}</slot>
      </div>
      <div class="c-crud-left"><slot name="left"></slot></div>
      <div class="c-crud-right"><slot name="right"></slot></div>
      <div class="c-crud-refresh">
        <el-button style="margin-left: 10px" circle plain icon="el-icon-refresh" v-if="onRefresh" @click="handleRefresh"></el-button>
      </div>
    </div>
    <div class="c-crud-body" v-loading="loading"><slot></slot></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    onLoad: {
      type: Function,
    },
    onRefresh: {
      type: Function,
    },
  },
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  computed: {},
  methods: {
    async handleLoad() {
      if (!this.onLoad) {
        return;
      }
      try {
        this.loading = true;
        await this.onLoad();
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },
    async handleRefresh() {
      if (!this.onRefresh) {
        return;
      }
      try {
        this.loading = true;
        await this.onRefresh();
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },
  },
  created() {},
  mounted() {
    this.handleLoad();
  },
  beforeDestroy() {},
  watch: {},
};
</script>
<style lang="scss">
.c-crud {
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  background-color: #ffffff;
  &-header {
    display: flex;
    flex-direction: row;
    margin: 0 0 14px;
    width: 100%;
    line-height: 32px;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 0;
    padding: 0 0 0;
    margin: 0 0 0;
  }

  &-title {
    font-size: 14px;
    font-weight: 500;
    color: $primary;
    line-height: 32px;
  }
  &-left {
    flex: 1;
  }
  &-right {
  }
}
</style>
